exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".PostRace > .Game-Board .PostRaceIntro .Text {\n  font-size: 12px;\n  font-weight: 200; }\n\n.PostRace > .Game-Board .PostRaceIntro-Wheels {\n  width: calc((100% - 60px) / 3 + 30px); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/Phases/PostRace/PostRace.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/pages/Phases/PostRace/PostRace.css
// module chunks = 0